module.exports = __webpack_public_path__ + "img/hero-poster_en.c22958d.jpg";